var primary = "#00234b";
var primaryOpacity = "rgba(0, 35, 75, 0.75)";
var primaryWithOpacity = "rgba(0, 35, 75, 0.5)";
var primaryOpaque = "rgba(0, 35, 75, 0)";
var primaryShadow = "rgba(0, 35, 75, 0.15)";
var greyOpacity = "rgba(0, 0, 0, 0.15)";
var darkGreyOpacity = "rgba(0,0,0,0.5)";
var secondary = "#5A7485";
var menu = "#46596b";
var gold = "#b4975a";
var grey = "#B1B1B1";
var greyBlue = "rgba(127,145,165,0.5)";
var greyBlue05 = "rgba(127,145,165,0.05)";
var greyBlue15 = "rgba(127,145,165,0.15)";
var greyBlue40 = "rgba(127,145,165,0.4)";
var greyBlue20 = "rgba(127,145,165,0.2)";
var lightgrey = "#f4f7f8";
var bgGrey = "#efefef";
var lightBgGrey = "#f7f7f7";
var darkgrey = "#dee2e3";
var disabledGrey = "#6c757d";
var darkerLtGrey = "#868e96";
var deepGrey = "#999999";
var black = "#000000";
var lightBlue = "#0082ce";
var white = "#FFFFFF";
var blueGrey = "#7f91a5";
var pearlGrey = "#DADCE0";
var successGreen = "#16B169";
var blue = "#006aa8";
var danger = "#9D2332";
var dangerLight = "#FFF2F2";
var bgDangerRed = "#FFF1F3";
var maroon = "#9D2332";
var skyBlue = "#8AC1FF";
var barelyBlue = "#FBFEFF";
var aqua = "#00BEDD";
var aquaHover = "#00adc9";
var orange = "#D98E4A";
var orangeHover = "#bd732f";
var colors = {
  primary: primary,
  secondary: secondary,
  menu: menu,
  gold: gold,
  lightBlue: lightBlue
};

export { aqua, aquaHover, barelyBlue, bgDangerRed, bgGrey, black, blue, blueGrey, danger, dangerLight, darkGreyOpacity, darkerLtGrey, darkgrey, deepGrey, colors as default, disabledGrey, gold, grey, greyBlue, greyBlue05, greyBlue15, greyBlue20, greyBlue40, greyOpacity, lightBgGrey, lightBlue, lightgrey, maroon, menu, orange, orangeHover, pearlGrey, primary, primaryOpacity, primaryOpaque, primaryShadow, primaryWithOpacity, secondary, skyBlue, successGreen, white };
